import { PropsWithClassname } from '@/app/types';

export const CheckGreen = ({ className }: PropsWithClassname) => {
  return (
    <svg fill="none" className={className} viewBox="0 0 24 24">
      <path
        d="M20 5.955 9 16.873l-5-4.962"
        stroke="#299B29"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
